import { WorkOrder } from "@/services/backend/rlt/work-orders/types/work-order";
import { useState } from "react";
import {
  UpdateInternalCommentRequest,
  useRltWorkOrderUpdateInternalCommentMutation,
} from "@/services/backend/rlt/work-orders/api/work-order-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import { TextareaField } from "@/shared/components/field/textarea-field";
import t from "@/lang/lang";

export function WorkOrderInternalCommentInput({
  workOrder,
  disabled = false,
}: {
  workOrder: WorkOrder;
  disabled?: boolean;
}) {
  const [request, setRequest] = useState<UpdateInternalCommentRequest>({
    id: workOrder.id,
    internalComment: workOrder.internalComment,
  });
  const mutation = useRltWorkOrderUpdateInternalCommentMutation();
  useDebouncedMutation(request, setRequest, mutation, {
    id: workOrder.id,
    internalComment: workOrder.internalComment,
  });

  return (
    <TextareaField
      label={t("Interner Kommentar")}
      value={request.internalComment}
      onChange={(e) =>
        setRequest({ ...request, internalComment: e.target.value })
      }
      fieldName="internalComment"
      debounce={false}
      disabled={disabled}
    />
  );
}
